import { pick } from 'ramda';

export default pick(['dateTime']);
